import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductModifierGroup } from "src/models/Products/ProductModifier.models";

interface ProductModifierGroupState {
  modifierGroups: IProductModifierGroup[];
  modifierGroupToEdit: IProductModifierGroup | null;
}

const initialState: ProductModifierGroupState = {
  modifierGroups: [],
  modifierGroupToEdit: null
}

const ProductModifierGroupSlice = createSlice({
  name: "ModifierGroup",
  initialState,
  reducers: {
    setProductModifierGroupList: (state, action: PayloadAction<IProductModifierGroup[]>) => {
      state.modifierGroups = action.payload;
    },
    concatListProductModifierGroup: (
      state: ProductModifierGroupState,
      action: PayloadAction<IProductModifierGroup[]>
    ) => {
      state.modifierGroups = [...state.modifierGroups.concat(action.payload)];
    },
    setProductModifierGroupToEdit: (state, action: PayloadAction<IProductModifierGroup | null>) => {
      state.modifierGroupToEdit = action.payload;
    },
    addProductModifierGroup: (state, action: PayloadAction<IProductModifierGroup>) => {
      state.modifierGroups.push(action.payload);
    },
    updateProductModifierGroup: (state, action: PayloadAction<IProductModifierGroup>) => {
      let itemIndex = state.modifierGroups.findIndex(
        item => item.productModifierGroupId === action.payload.productModifierGroupId
      );
      if (itemIndex !== -1) state.modifierGroups[itemIndex] = action.payload;
    },
    deleteProductModifierGroup: (state, action: PayloadAction<string>) => {
      const newArray = state.modifierGroups.filter(
        item => item.productModifierGroupId !== action.payload
        );
      state.modifierGroups = newArray;
    },
  },
});

export const {
  setProductModifierGroupList,
  concatListProductModifierGroup,
  setProductModifierGroupToEdit,
  addProductModifierGroup,
  updateProductModifierGroup,
  deleteProductModifierGroup,
} = ProductModifierGroupSlice.actions;

export default ProductModifierGroupSlice.reducer;